import { render, staticRenderFns } from "./RcWidgetLiveResultsPresident.vue?vue&type=template&id=1df9618a&"
import script from "./RcWidgetLiveResultsPresident.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsPresident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports